import { DataTableColumn } from './DataTableColumn';

export function expandCols<T = any>(cols: (string | DataTableColumn<T>)[]):DataTableColumn<T>[] {
  return cols.map(c => typeof c == 'string' ? {id: c} : c);
}
